module.exports = __webpack_public_path__ + "static/img/8.f5cdd455.png";